// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2conj","buttons":"RemoveExpirationActionButtons_buttons__2ies_"};